module.exports = __webpack_public_path__ + "public/img/PMS - Header Banner 4.56b6e00a.png";